<template>
  <q-inner-loading v-if="loading" showing color="secondary" />
  <market-report-settings
    v-else-if="report"
    :report="report"
    @submit="submit"
    @delete="deleteSubscription"
  />
</template>

<script lang="ts">
import type { MarketReportSubscriptionAttributes } from 'common'
import { useMarketReportStore } from '@/stores/marketreport'
import MarketReportSettings from '@/components/MarketReports/MarketReportSettings.vue'
import { useUserStore } from '@/stores/user'

export default {
  name: 'MarketReportEditView',
  components: {
    MarketReportSettings
  },
  props: {
    reportId: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      loading: false,
      report: null as MarketReportSubscriptionAttributes | null
    }
  },
  computed: {
    organizationMembers() {
      return useUserStore().organizationMembers
    }
  },
  watch: {
    organizationMembers() {
      this.checkAuthorization()
    }
  },
  mounted() {
    this.loading = true
    useMarketReportStore()
      .get(parseInt(this.reportId))
      .then((response) => {
        if (!response) {
          this.$router.push({ name: 'Regional Reports' })
        } else {
          this.report = response
          this.checkAuthorization()
        }
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    checkAuthorization() {
      const ownerIds = this.organizationMembers.map((_) => _.id)
      const ownerId = this.report?.user_id
      if (ownerIds.length && ownerId && !ownerIds.includes(ownerId)) {
        this.$router.push({ name: 'Regional Reports' })
      }
    },
    submit(report: MarketReportSubscriptionAttributes) {
      if (!report) {
        console.warn('No report to update')
        return
      }
      useMarketReportStore()
        .update(report)
        .then((res) => {
          if (res) {
            this.$tracker.updatedReport(res.id, 'market')
            this.$router.push({ name: 'Regional Report', params: { reportId: res.id } })
          } else {
            this.$q.notify({
              message: 'Failed to update report',
              color: 'negative',
              position: 'top'
            })
            console.error('Failed to update report', res)
          }
        })
    },
    deleteSubscription() {
      useMarketReportStore()
        .delete(parseInt(this.reportId))
        .then(() => {
          this.$tracker.deletedReport(parseInt(this.reportId), 'market')
          this.$router.push({ name: 'Regional Reports' })
        })
    }
  }
}
</script>
